
import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";
import * as Snackbar from "node-snackbar";
import FSnackbar from "@/fsnackbar";
import FFormMDP from "@/components/form/FFormMDP";
import { FFormChildMDP } from "@/components/form/FFormDrawerMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";
import FTextareaMDP from "@/components/form/field/FTextareaMDP";
import FFileFieldMDP from "@/components/form/field/FFileFieldMDP";
import FPANTextFieldMDP from "@/components/form/field/FPANTextFieldMDP";
import FBtnMDP from "@/components/FBtnMDP";


export default class ECFTSalesFeedbackStepMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  taskRoot: any;
  parent: any;
  selectedOption: string;
  constructor({ taskRoot, parent }: { taskRoot: any; parent: any }) {
    super({
      myRefName: "salesFeedbackFormRef",
      disabled: taskRoot.taskDisabled,
      colWidth: 12,
    });
    this.taskRoot = taskRoot;
    this.parent = parent;

    this
    .addField(
      new FTextFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "taskOutput.clientFileSummary.salesRepAssignedStage",
        label: "Drop-off stage:",
        boundaryClass: "col-4",
        readonly: true,
      })
    ).addField(
      new FTextareaMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "taskOutput.clientFileSummary.dropOffReason",
        label: "Reason for Drop-off:",
        mandatory: true,
        boundaryClass: "col-12",
      })
    );

    this.addField(
      new FFileFieldMDP({
        dataSelectorKey: "panFromImgInput.panImage",
        label: "Please upload a valid PAN card image (JPG, PNG)",
        parentMDP: this.childMDP,
        condition: !this.taskRoot.isPANInputShow,
      })
    )
      .addField(
        new FPANTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "panFromImgInput.pan",
          label: "PAN",
          boundaryClass: "col-12",
          mandatory: true,
          rules: "validate_pan",
          panVerified: this.taskRoot.isPanVerified,
          condition: this.taskRoot.isPANInputShow,
        })
      )
      .addAction(
        new FBtnMDP({
          label: "Cancel",
          onClick: () => this.handleCancelClick(),
          condition: this.taskRoot.isVerifyBtn,
        })
      )
      .addAction(
        new FBtnMDP({
          label: "Upload PAN",
          onClick: () => this.handleUploadPANClick(),
          condition: !this.taskRoot.isPANInputShow,
          customButtonLoading: this.taskRoot.isLoadingApi,
        })
      )
      .addAction(
        new FBtnMDP({
          label: "Verify PAN",
          onClick: () => this.handleVerifyClick(),
          condition: this.taskRoot.isVerifyBtn,
          customButtonLoading: this.taskRoot.isLoadingApi,
        })
      );
  }

  getMyRef() {
    return this.parent.getMyRef().$refs[this.myRefName][0];
  }

  validateAndSubmit() {
    if (this.taskRoot.isPanVerified) {
      return (nextCallback?: () => void) => {
        this.getMyRef().submitForm(() => {
          if (
            this.taskRoot.clientFileSummary.mode === "APP" ||
            this.taskRoot.clientFileSummary.mode === "TKN"
          ) {
            this.updateDropOffReason(nextCallback);
          } else {
            this.getMyRef().submitForm(() => {
              this.updateDropOffReason(nextCallback);
            });
          }
        });
      };
    } else {
      return (nextCallback?: () => void) => {
        const isCreditReady =
          this.taskRoot.clientFileEnrollmentSummary.enrollmentSummary
            .isCreditorDone ||
          this.taskRoot.clientFileEnrollmentSummary.enrollmentSummary
            .isCreditReportPulled;
        if (isCreditReady) {
          this.getMyRef().submitForm(() => {
            if (
              this.taskRoot.clientFileSummary.mode === "APP" ||
              this.taskRoot.clientFileSummary.mode === "TKN"
            ) {
              this.updateDropOffReason(nextCallback);
            } else {
              this.getMyRef().submitForm(() => {
                this.updateDropOffReason(nextCallback);
              });
            }
          });
        } else {
          if (this.taskRoot.isPanVerified) {
            this.getMyRef().submitForm(() => {
              this.updateDropOffReason(nextCallback);
            });
          } else {
            FSnackbar.error(
              "Note : The client should login to PWA and pull the credit report before you proceed."
            );
          }
        }
      };
    }
  }

  // validateAndSubmit() {
  //   return (nextCallback?: () => void) => {
  //     if (
  //       this.taskRoot.clientFileSummary.mode === "APP" ||
  //       this.taskRoot.clientFileSummary.mode === "TKN"
  //     ) {
  //       this.getMyRef().submitForm(() => {
  //         this.updateDropOffReason(nextCallback);
  //       });
  //     } else {
  //       this.updateDropOffReason(nextCallback);
  //     }
  //   };
  // }

  updateDropOffReason(callback?: () => void) {
    // const input = new Data.Spine.UpdateDropOffReasonInput();
    // input.clientFileId =
    //   this.taskRoot.taskFormData.taskOutput.clientFileBasicInfo.clientFileId;
    // input.dropOffStage =
    //   this.taskRoot.taskFormData.taskOutput.clientFileSummary.salesRepAssignedStage;
    // input.dropOffReason =
    //   this.taskRoot.taskFormData.taskOutput.clientFileSummary.dropOffReason;

    // Action.Spine.UpdateDropOffReason.execute(input, (output: any) => {
    //   FSnackbar.success("Succesfully saved");
    //   if (callback) {
    //     callback();
    //   }
    // });
  }

  handleUploadPANClick() {
    return new Promise((resolve) => {
      this.taskRoot.getPanFromImg();
      resolve(true);
    });
  }

  handleVerifyClick() {
    return new Promise((resolve) => {
      this.taskRoot.conditionallyAddPan();
      resolve(true);
    });
  }

  handleCancelClick() {
    this.taskRoot.isPANInputShow = false;
    this.taskRoot.isVerifyBtn = false;
  }
}
